import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import {TopButtonPointAction, TopButtonPointRemove} from "../../../../../componentsTopsa/buttons/TopButtons";
import tabgrid from "../../../../../utilities/TabGrid";
import {FormControl} from "react-bootstrap";
import DateAndTimeFormat from "../../../../../utilities/DateAndTimeFormat";
import TabUtilities from "../../../../../utilities/TabUtilities";
import DefinicjaGodzinyStartowejSelectEkipa from "./DefinicjaGodzinyStartowejSelectEkipa";
import DefinicjaGodzinyStartowejInputZmiana from "./DefinicjaGodzinyStartowejInputZmiana";


export default class DefinicjaGodzinyStartowejTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            edytowany_obj: null,
            nowa_godz: '',
        };
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
        this.renderTrasa = this.renderTrasa.bind(this)
        this.renderKalendarz = this.renderKalendarz.bind(this)
        this.renderGodzina = this.renderGodzina.bind(this)
        this.renderEkipa = this.renderEkipa.bind(this)
        this.renderZmiana = this.renderZmiana.bind(this)
        this.onChangeGodzina = this.onChangeGodzina.bind(this)
        this.onChangeEkipa = this.onChangeEkipa.bind(this)
        this.onChangeZmiana = this.onChangeZmiana.bind(this)
        this.onClickZapiszEdycje = this.onClickZapiszEdycje.bind(this)
        this.onClickAnulujEdycje = this.onClickAnulujEdycje.bind(this)
        this.onClickForm = this.onClickForm.bind(this)
    }

    renderButtonyAkcji(cell, row) {
        return (
            <div>
                <TopButtonPointRemove onClick={() => {
                    this.props.handleUsun(row)
                }} titleContent={'Usuń godzinę'}/>
            </div>
        )
    }

    renderTrasa(cell, row) {
        let trasa = this.props.trasy.find(t => t.idTr === cell);
        if (Boolean(trasa)) {
            return (
                <div>
                    <span className={'label label-ebus-default'}>{trasa.kodTrasy}</span> {trasa.nazTr}
                </div>
            )
        }

    }

    renderKalendarz(cell, row) {
        let kalendarz = this.props.kalendarze.find(k => k.idRk === cell);
        if (Boolean(kalendarz)) {
            return kalendarz.nazRk
        }
    }

    renderGodzina(cell, row) {

        let godz = DateAndTimeFormat.formatNormalTime(cell)
        return (
            <div>
                <div style={{width: '200px', display: 'inline-block'}}>
                    <FormControl type={'time'}
                                 defaultValue={godz} onChange={(e) => this.onChangeGodzina(e)}
                                 id={'input' + row.idTrk}
                                 onClick={(e) => {
                                     this.onClickForm(e, row)
                                 }}
                    />
                </div>
                <span>
                    {
                        Boolean(this.state.edytowany_obj) ?
                            Boolean(this.state.edytowany_obj.idTrk === row.idTrk) ?
                                <span>
                                    <TopButtonPointAction onClick={this.onClickZapiszEdycje}
                                                          buttonIcon={'fa fa-check'}
                                                          titleContent={'Zapisz godzinę'}
                                                          buttonColor={'primary'}
                                    />
                                    <TopButtonPointAction onClick={() => this.onClickAnulujEdycje('input' + row.idTrk)}
                                                          buttonIcon={'fa fa-times'}
                                                          titleContent={'Anuluj edycję'}
                                                          buttonColor={'default'}
                                    />
                                </span>
                                :
                                ''
                            :
                            ''
                    }
                </span>
            </div>
        )

    }

    renderEkipa(cell, row) {
        return <DefinicjaGodzinyStartowejSelectEkipa ekipy={this.props.ekipy} handleChangeEkipa={this.onChangeEkipa} obecnaEkipa={row.idEk}
                                                     rekord={row}/>
    }

    renderZmiana(cell, row) {
        return <DefinicjaGodzinyStartowejInputZmiana obecnaZmiana={row.zmiana} rekord={row} handleChangeZmiana={this.onChangeZmiana}/>
    }

    onChangeZmiana(zmiana, rekord) {
        let data = {
            "godz1p": rekord.godz1p,
            "idEk": rekord.idEk,
            "idRk": rekord.idRk,
            "idTr": rekord.idTr,
            "idTrk": rekord.idTrk,
            "zmiana": zmiana
        }
        this.props.handleEdycjaGodziny(data);
    }

    onClickForm(e, obj) {
        this.setState({edytowany_obj: obj, nowa_godz: DateAndTimeFormat.formatHHMM(obj.godz1p)})
    }

    onChangeEkipa(ekipa, rekord) {
        let data = {
            "godz1p": rekord.godz1p,
            "idEk": ekipa.idEk,
            "idRk": rekord.idRk,
            "idTr": rekord.idTr,
            "idTrk": rekord.idTrk,
            "zmiana": rekord.zmiana
        }
        this.props.handleEdycjaGodziny(data);
    }

    onChangeGodzina(e) {
        this.setState({
            nowa_godz: e.target.value
        })
    }

    onClickAnulujEdycje(input) {
        document.getElementById(input).value = DateAndTimeFormat.formatHHMM(this.state.edytowany_obj.godz1p)
        this.setState({
            edytowany_obj: null,
            nowa_godz: '',
        })
    }

    onClickZapiszEdycje() {
        if (Boolean(this.state.edytowany_obj) && this.state.nowa_godz.length > 0) {
            let data = {
                "godz1p": parseFloat((this.state.nowa_godz).replace(':', '.')),
                "idRk": this.state.edytowany_obj.idRk,
                "idTr": this.state.edytowany_obj.idTr,
                "idTrk": this.state.edytowany_obj.idTrk,
                "idEk": this.state.edytowany_obj.idEk,
                "zmiana": this.state.edytowany_obj.zmiana
            }

            this.props.handleEdycjaGodziny(data);
            this.setState({
                edytowany_obj: null,
                nowa_godz: '',
            })
        }
    }

    render() {

        return (
            <div>
                <BootstrapTable data={this.props.data}
                                hover
                                multiColumnSort={2}
                                options={{noDataText: 'Brak pasujących rekordów'}}
                >
                    <TableHeaderColumn dataField='idTrk' isKey hidden={true}>ID</TableHeaderColumn>
                    <TableHeaderColumn dataField='idTr'
                                       thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.renderTrasa}
                    >Nazwa trasy</TableHeaderColumn>
                    <TableHeaderColumn dataField='idRk'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.renderKalendarz}
                    >Rodzaj kalendarza</TableHeaderColumn>
                    <TableHeaderColumn dataField='godz1p'
                                       thStyle={tabgrid.tg5} tdStyle={tabgrid.tg5}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.renderGodzina}
                                       dataSort
                    >Godzina odjazdu z pierwszego przystanku</TableHeaderColumn>
                    <TableHeaderColumn dataField='idEk'
                                       thStyle={tabgrid.tg5} tdStyle={tabgrid.tg5}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.renderEkipa}
                    >Ekipa</TableHeaderColumn>
                    <TableHeaderColumn dataField='zmiana'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.renderZmiana}
                    >Zmiana</TableHeaderColumn>
                    <TableHeaderColumn dataField='idTrk'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       dataFormat={this.renderButtonyAkcji}
                    >{TabUtilities.returnAkcjaDowolnaHtml()}</TableHeaderColumn>

                </BootstrapTable>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/definicjeGodzinStartowychjDlaTrasy/components/DefinicjaGodzinyStartowejTable.js